import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {TransactionSummaryDoughnutChartCard} from '@/components/composite'
import {PosTransactionSummaryDoughnutChartCardStoreType} from '@/pages/Reports/components'
import {TSelectContainerStore} from '@/components/containers'

export const POSCardSchemeStoreSymbol = Symbol('POSCardSchemeStore')
export const POSCardSchemeStatusStoreSymbol = Symbol('POSCardSchemeStatusStore')

export const POSCardSchemeDoughnutChartContainer = observer(() => {
    const { t } = useTranslation()
    const store =
        useInjection<PosTransactionSummaryDoughnutChartCardStoreType>(POSCardSchemeStoreSymbol)
    const selectStore = useInjection<TSelectContainerStore>(POSCardSchemeStatusStoreSymbol)

    return (
        <TransactionSummaryDoughnutChartCard
            tooltipText={t('Reports.cardScheme')}
            amountData={store.amountData}
            countData={store.countData}
            tabType={store.chartType}
            setChartType={store.setChartTabType}
            title={t('Reports.cardScheme')}
            centerTitle={t('Reports.volumeTotal')}
            selectStatusProps={{
                value: selectStore.value,
                options: selectStore.options,
                onChange: selectStore.setValue
            }}
            loadingState={store.amountLoadingState}
            currency={store.currency}
        />
    )
})
